export default __webpack_public_path__ + "static/media/brisbane.b1a621c7.svg";